export const DRAFT = 'Draft';
export const ACTIVE = 'activeListed';
export const SOLD = 'Sold';
export const UNLISTED = 'Unlisted';
export const DELETED = 'Deleted';
